"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ShadingHelper = void 0;
var shading_info_1 = require("../../../../core/model/shadings/shading-info");
var shading_pattern_1 = require("../../../../core/model/shadings/shading-pattern");
var translation_tables_1 = require("../../../translation-table/translation-tables");
var open_xml_color_import_helper_1 = require("../../color/open-xml-color-import-helper");
var ShadingHelper = (function () {
    function ShadingHelper() {
    }
    ShadingHelper.getShadingValue = function (data, reader) {
        var colorCache = data.documentModel.cache.colorModelInfoCache;
        var shadingPattern = data.readerHelper.getWpEnumValue(reader, 'val', translation_tables_1.TranslationTables.shadingPatternTable.importMap, shading_pattern_1.ShadingPattern.Clear);
        var foreColorModelInfo = colorCache.getItem(open_xml_color_import_helper_1.OpenXmlColorImportHelper.createColorModelInfo(data, reader, 'color'));
        var backColorModelInfo = colorCache.getItem(open_xml_color_import_helper_1.OpenXmlColorImportHelper.createFillInfo(data, reader));
        return data.documentModel.cache.shadingInfoCache.getItem(new shading_info_1.ShadingInfo(shadingPattern, backColorModelInfo, foreColorModelInfo));
    };
    return ShadingHelper;
}());
exports.ShadingHelper = ShadingHelper;
